import { apiClient } from './api'

export type OrgCustomFieldEntityType =
  | 'project'
  | 'task'
  | 'milestone'
  | 'portfolio'
  | 'program'

export type OrgCustomFieldType =
  | 'text'
  | 'longtext'
  | 'number'
  | 'date'
  | 'select'
  | 'multiselect'
  | 'url'
  | 'user'
  | 'currency'

export interface OrgCustomFieldOption {
  value: string
  label: string
}

export interface OrgCustomField {
  id: number
  organization_id: number | null
  entity_type: OrgCustomFieldEntityType
  key: string
  label: string
  field_type: OrgCustomFieldType
  options: OrgCustomFieldOption[] | null
  required: boolean
  display_order: number
  help_text: string | null
}

export interface EntityFieldValues {
  entity_type: OrgCustomFieldEntityType
  entity_id: number
  values: Record<string, unknown>
}

export const orgCustomFieldsService = {
  list: (orgId: number, entityType?: OrgCustomFieldEntityType) =>
    apiClient
      .get<OrgCustomField[]>(`/api/v1/organizations/${orgId}/custom-fields`, {
        params: entityType ? { entity_type: entityType } : {},
      })
      .then(r => r.data),

  create: (orgId: number, data: Partial<OrgCustomField> & { entity_type: OrgCustomFieldEntityType; key: string; label: string; field_type: OrgCustomFieldType }) =>
    apiClient
      .post<OrgCustomField>(`/api/v1/organizations/${orgId}/custom-fields`, data)
      .then(r => r.data),

  update: (orgId: number, fieldId: number, data: Partial<OrgCustomField>) =>
    apiClient
      .patch<OrgCustomField>(`/api/v1/organizations/${orgId}/custom-fields/${fieldId}`, data)
      .then(r => r.data),

  remove: (orgId: number, fieldId: number) =>
    apiClient.delete<void>(`/api/v1/organizations/${orgId}/custom-fields/${fieldId}`),

  getValues: (
    entityType: OrgCustomFieldEntityType,
    entityId: number,
    orgId?: number,
  ) =>
    apiClient
      .get<EntityFieldValues>(`/api/v1/entities/${entityType}/${entityId}/custom-field-values`, {
        params: orgId != null ? { organization_id: orgId } : {},
      })
      .then(r => r.data),

  setValues: (
    entityType: OrgCustomFieldEntityType,
    entityId: number,
    values: Record<string, unknown>,
    orgId?: number,
  ) =>
    apiClient
      .put<EntityFieldValues>(
        `/api/v1/entities/${entityType}/${entityId}/custom-field-values`,
        { values },
        { params: orgId != null ? { organization_id: orgId } : {} },
      )
      .then(r => r.data),
}
